
// import {dwJSPath} from '../../helpers/born.utils';

let util = require('../../util');

import dwUtils from '../../util';
import dwValidator from '../../validator';

import * as Utils from '../../helpers/born.utils';
import TrackingLayer from '../../modules/module.tracking-layer';
import _ from 'lodash';

var progress = require('_core/progress');

function addSubHandler() {
	let form = document.querySelector('.footer__subscribe__form'),
		subFormSettings = $.extend(true, {submitHandler: sendSubRequest}, dwValidator.settings);

	$(form).find('input').on('change', function(){
		$(this).closest('.footer__subscribe').find('.footer__subscribe__message').remove();
	});

	dwValidator.initForm(form, subFormSettings);
}

function sendSubRequest(form) {
	
	TrackingLayer.pushData('mail_signup: ' + window.Resources['USER_SIGNUP']);

	progress.show($('body'));

	return true;
}


/**
 * Cookie agreement functionality
*/

function readAgreementCookie() {
	if( !Utils.readCookie('modist--agreed-browse') ) {
		let cookieAgreement = document.querySelector('.cookie-agreement');

		cookieAgreement.showContent();

		cookieAgreement.afterContentHide = function() {
			Utils.createCookie('modist--agreed-browse', true, 1000);
		};
	}
}

let backToTop = document.querySelector('.back-to-top');

function stickBackToTop() {
	var scrollBreakpoint = util.isMobile() ? 20 : 650;
	var scrolledDistance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
	
	backToTop.classList[scrolledDistance >= scrollBreakpoint ? 'add' : 'remove']('set--active');
}

function genderSelectionCheckmarkToggle() {
    $('.gender-radio').each(function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('selected');
        }
    });
    $('.gender-radio').on('change', function () {
        $('.gender-selection-radio').removeClass('selected');
        $(this).parent().addClass('selected');
    });
}

function footerGAEvents(){
	var user = dataLayer.find(o => o.user != null).user;
	$('.footer__col .footer__list .footer__list__item .footer__list__anchor').on('click', function (e) {
		dataLayer.push({
			'event': 'custom_event',
			'eventCategory': 'footer_navigation',
			'eventAction': 'footer_navigation_click',
			'eventLabel': $(this).text(),
			'country': window.GlobalAttributes.COUNTRY,
			'language': window.GlobalAttributes.LANGUAGE,
			'screenName': 'Footer navigation',
			'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
			'userId': user.user_id != '' ? user.user_id : ''
		});
	})
	$('.footer__container .footer__col .footer__social-item').on('click', function (e) {
		dataLayer.push({
			'event': 'custom_event',
			'eventCategory': 'footer_navigation',
			'eventAction': 'footer_navigation_social_icon',
			'eventLabel': $(this).data('sharing-option'),
			'country': window.GlobalAttributes.COUNTRY,
			'language': window.GlobalAttributes.LANGUAGE,
			'screenName': 'Footer navigation',
			'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
			'userId': user.user_id != '' ? user.user_id : ''
		});
	})
	$('.footer__container .footer__col--app-links a').on('click', function (e) {
		dataLayer.push({
			'event': 'custom_event',
			'eventCategory': 'footer_navigation',
			'eventAction': 'footer_navigation_app_download_click',
			'eventLabel': $(this).data('app-name'),
			'country': window.GlobalAttributes.COUNTRY,
			'language': window.GlobalAttributes.LANGUAGE,
			'screenName': 'Footer navigation',
			'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
			'userId': user.user_id != '' ? user.user_id : ''
		});
	})
	$('.footer__subscribe__form button').on('click', function (e) {
		if ($('#dwfrm_moengage_emailsignup_email-error').length > 0) {
			dataLayer.push({
				'event': 'custom_event',
				'eventCategory': 'footer_navigation',
				'eventAction': 'newsletter_failed',
				'eventLabel': 'newsletter failed',
				'failedReason': $('#dwfrm_moengage_emailsignup_email-error').text(),
				'country': window.GlobalAttributes.COUNTRY,
				'language': window.GlobalAttributes.LANGUAGE,
				'screenName': 'Footer navigation',
				'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
				'userId': user.user_id != '' ? user.user_id : ''
			});
		}
	})
}

export default function() {
	addSubHandler();
    genderSelectionCheckmarkToggle();
	if(backToTop) {
		window.addEventListener('scroll', _.debounce(stickBackToTop, 100, {leading: true}));
	}
	footerGAEvents();
}




// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/sections/footer.js